/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type SentimentFilterConfigColumn =
  (typeof SentimentFilterConfigColumn)[keyof typeof SentimentFilterConfigColumn];

export const SentimentFilterConfigColumn = {
  sentiment: 'sentiment',
} as const;
